import { Stack } from '@mui/material'
import { useUser } from '../auth/hooks/useUser'
import type { SearchResultItem } from '../search/types'
import { MediaBackdrop } from './components/Backdrop'
import { ConfirmModal } from './components/Modal'
import { InformationTable } from './components/Table'
import { Preview } from './preview/Preview'

interface Props {
  openDrawer: boolean
  searchResultItem: SearchResultItem
  url: string
}

export const MediaDetailsContent = (props: Props) => {
  const { openDrawer, searchResultItem, url } = props
  const {
    selectors: { selectUserRole },
  } = useUser()
  const userRole = selectUserRole()
  const hasAccess = userRole === 'admin' || userRole === 'provider'

  return (
    <Stack direction={openDrawer ? 'column' : 'row'} gap={2}>
      <Preview
        openDrawer={openDrawer}
        searchResultItem={searchResultItem}
        url={url}
      />

      <InformationTable
        openDrawer={openDrawer}
        searchResultItem={searchResultItem}
        title="Information"
      />

      {hasAccess && (
        <InformationTable
          openDrawer={openDrawer}
          searchResultItem={searchResultItem}
          title="Information for Providers"
        />
      )}

      <ConfirmModal />
      <MediaBackdrop />
    </Stack>
  )
}
